<template>
  <Modal
    :modal-style="{ maxWidth: '45vw' }"
    :title="$t('modals.select_top_trends_modal.title')"
  >
    <div
      key="form"
      class="q-pa-xs scroll column"
      :class="{ 'q-pa-md': $isDesktop }"
      style="max-height: 80vh"
    >
      <div
        v-if="error"
        class="q-mb-md row justify-center"
      >
        {{ $t("modals.select_top_trends_modal.load_error") }}
      </div>
      <div v-else>
        <div class="row q-gutter-md q-mb-md justify-center">
          <BaseButton
            class="col-3"
            :class="{ 'opacity-5': interval !== '1d' }"
            color="secondary"
            :label="$t('modals.select_top_trends_modal.one_day_button')"
            new-design
            @click="toggleInterval('1d')"
          />
          <BaseButton
            class="col-3"
            :class="{ 'opacity-5': interval !== '7d' }"
            color="secondary"
            :label="$t('modals.select_top_trends_modal.seven_day_button')"
            new-design
            @click="toggleInterval('7d')"
          />
        </div>
        <div
          v-for="trend in trends"
          :key="trend.title"
          class="row full-width justify-between"
        >
          <Checkbox
            :class="{
              'col-8': includeSyndication,
              'col-12': !includeSyndication,
            }"
            :label="trend.title"
            new-design
            @update:model-value="toggleTrend(trend)"
          />
          <QSelect
            v-if="includeSyndication"
            v-model="trend.id"
            class="col-4"
            emit-value
            filled
            map-options
            option-label="source"
            option-value="id"
            :options="trend.siblings"
          />
        </div>
      </div>
    </div>

    <template #buttons>
      <BaseButton
        :disable="disableButton"
        :label="$t('global.cancel')"
        new-design
        @click.prevent="close"
      />
      <BaseButton
        color="primary"
        :disable="disableButton"
        :label="$t('global.insert')"
        new-design
        @click="insertTrends"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "SelectTopTrendsModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    includeUrls: {
      type: Boolean,
    },
    includeSyndication: {
      type: Boolean,
    },
  },
  emits: ["build"],
  data() {
    return {
      error: false,
      interval: "1d",
      trends: [],
      selectedTrends: [],
    };
  },
  computed: {
    disableButton() {
      return !this.selectedTrends.length;
    },
    formattedTrends() {
      return this.selectedTrends.map((trend) => ({
        id: trend.id,
        title: trend.title,
        counts: trend.counts,
        source: this.selectedSource(trend),
        ...(this.includeUrls ? { url: trend.url } : {}),
      }));
    },
  },
  async mounted() {
    await this.getTopTrends();
  },
  methods: {
    async getTopTrends() {
      try {
        this.trends = (
          await this.$streemApiV1.get("trending", {
            params: {
              interval: this.interval,
              ...(this.includeUrls ? { include_urls: true } : {}),
              ...(this.includeSyndication ? { include_syndication: true } : {}),
            },
          })
        ).data;
      } catch {
        this.error = true;
      }
    },
    insertTrends() {
      this.$emit("build", this.formattedTrends);
      this.close();
    },
    close() {
      this.$modals.close("SelectTopTrendsModal");
    },
    toggleInterval(val) {
      this.interval = val;
      this.selectedTrends = [];
      this.getTopTrends();
    },
    toggleTrend(val) {
      const index = this.selectedTrends.findIndex(
        ({ title }) => title === val.title
      );

      if (index < 0) {
        this.addTrend(val);
      } else {
        this.removeTrend(index);
      }
    },
    addTrend(val) {
      this.selectedTrends.push(val);
    },
    removeTrend(index) {
      this.selectedTrends.splice(index, 1);
    },
    selectedSource(selectedTrend) {
      const trend = this.trends.find(
        ({ title }) => title === selectedTrend.title
      );

      if (!trend.siblings) return null;

      const sibling = trend.siblings.find(({ id }) => id === selectedTrend.id);

      return sibling?.source;
    },
  },
};
</script>
